import axios from "axios"

// import { DefaultFunctionURL } from "./url.service"
import { API_BASE_URL } from "./services.config"

export class BufferService {
  constructor(name, api = "main") {
    const baseUrl = API_BASE_URL[api] ?? API_BASE_URL.main
    if (!baseUrl) {
      console.log(`API base URL not defined for api "${api}"`)
    }
    this.url = baseUrl.endsWith("/") ? baseUrl : baseUrl + "/"
    this.entityName = name
  }

  async get() {
    const lists = await axios
      .get(this.url + this.entityName)
      .then(function (response) {
        return response.data
      })
      .catch(function (error) {
        return error
      })
    return lists
  }

  async getId(id) {
    const lists = await axios
      .get(this.url + this.entityName + "/" + id)
      .then(function (response) {
        return response.data
      })
      .catch(function (error) {
        return error
      })
    return lists
  }

  async options() {
    const metadata = await axios
      .options(this.url + this.entityName)
      .then(function (response) {
        return response.data
      })
      .catch(function (error) {
        return error
      })
    return metadata
  }

  async post(data) {
    const res = await axios
      .post(this.url + this.entityName, data)
      .then(function (response) {
        return response.data
      })
      .catch(function (error) {
        return error
      })
    return res
  }

  async delete(id) {
    const res = await axios
      .delete(this.url + this.entityName + "/" + id)
      .then(function (response) {
        return response.data
      })
      .catch(function (error) {
        return error
      })
    return res
  }

  async update(id, data) {
    const res = await axios
      .put(this.url + this.entityName + "/" + id, data)
      .then(function (response) {
        return response.data
      })
      .catch(function (error) {
        return error
      })
    return res
  }

  async filter(filter) {
    const filterList = await axios
      .get(this.url + this.entityName + filter)
      .then(function (response) {
        return response.data
      })
      .catch(function (error) {
        return error
      })
    return filterList
  }
  async patch(path, data) {
    const res = await axios
      .patch(this.url + this.entityName + '/' + path, data)
      .then(function (response) {
        return response.data
      })
      .catch(function (error) {
        return error
      })
    return res
  }

  async postTo(path, data) {
    const res = await axios
      .post(this.url + this.entityName + '/' + path, data)
      .then(function (response) {
        return response.data
      })
      .catch(function (error) {
        return error
      })
    return res
  }
  async put(data) {
    const res = await axios
        .put(this.url + this.entityName, data)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error
        })
    return res
}
}